import './styles.scss';
import React from 'react';
import {Card, Col, Collapse, Descriptions, Row, Statistic} from "antd";
import {IContract} from "../../../api/Contract/Contract.types";
import moment from "moment";
import NumbersUtil from "../../../global/utils/number";
import {CalendarOutlined, DollarOutlined, GroupOutlined} from "@ant-design/icons";

interface Props {
    contract: IContract
}

function ContractDetails({contract}: Props) {

    return (
        <div className='contract-details-component'>
            <div className='contract-details-header'>
                <div className='top'>
                    <div className='piid'>PIID: {contract.piid}</div>
                    <div className='signed-date'>Signed
                        on: {contract.signedDate ? moment(contract.signedDate).format('MMM DD, YYYY') : "N/A"}</div>
                </div>
                <div className='description'>
                    {contract.description}
                </div>

            </div>
            <Row gutter={24} style={{marginBottom: 24}}>
                <Col span={8}>
                    <Card>
                        <Statistic
                            title={<div className='total-statistic'><GroupOutlined/>Vendor Name</div>}
                            value={contract.vendorName}
                            valueStyle={{color: '#3f8600'}}
                        />
                    </Card>
                </Col>
                <Col span={8}>
                    <Card>
                        <Statistic
                            title={<div className='total-statistic'><DollarOutlined/>Obligated Amount</div>}
                            value={"$" + NumbersUtil.toShortened(contract.obligatedAmount, 2)}
                            valueStyle={{color: '#3f8600'}}
                        />
                    </Card>
                </Col>
                <Col span={8}>
                    <Card>
                        <Statistic
                            title={<div className='total-statistic'><CalendarOutlined/>Start Date</div>}
                            value={contract.startDate ? moment(contract.startDate).format('MMM DD, YYYY') : "N/A"}
                            valueStyle={{color: '#3f8600'}}
                        />
                    </Card>
                </Col>
            </Row>
            <Collapse>
                <Collapse.Panel key={1} header='Vendor Info'>
                    <Descriptions size="small" bordered labelStyle={{width:200}}
                                  column={{xxl: 1, xl: 1, lg: 1, md: 1, sm: 1, xs: 1}}>
                        <Descriptions.Item label='Cage Code'>
                            {contract.cageCode || "N/A"}
                        </Descriptions.Item>
                        <Descriptions.Item label='Vendor DUNS'>
                            {contract.vendorDuns}
                        </Descriptions.Item>
                        <Descriptions.Item label='Global DUNS'>
                            {contract.globalDuns}
                        </Descriptions.Item>
                        <Descriptions.Item label='SAM UEI'>
                            {contract.samId}
                        </Descriptions.Item>
                        <Descriptions.Item label='Parent SAM UEI'>
                            {contract.parentSamId}
                        </Descriptions.Item>
                    </Descriptions>
                    <Descriptions size="small" bordered style={{margin: '24px 0'}} labelStyle={{width:200}}
                                  column={{xxl: 1, xl: 1, lg: 1, md: 1, sm: 1, xs: 1}}>
                        <Descriptions.Item label='Contractor Name'>
                            {contract.contractorName}
                        </Descriptions.Item>
                        <Descriptions.Item label='Contractor DBA'>
                            {contract.contractorDba}
                        </Descriptions.Item>
                        <Descriptions.Item label='Vendor Phone Number'>
                            {contract.vendorPhone}
                        </Descriptions.Item>
                        <Descriptions.Item label='Vendor City'>
                            {contract.vendorCity}
                        </Descriptions.Item>
                        <Descriptions.Item label='Vendor State'>
                            {contract.vendorState}
                        </Descriptions.Item>
                    </Descriptions>

                    <Descriptions size="small" bordered style={{margin: '24px 0'}} labelStyle={{width:200}}
                                  column={{xxl: 1, xl: 1, lg: 1, md: 1, sm: 1, xs: 1}}>
                        <Descriptions.Item label='For Profit?'>
                            {contract.forProfit}
                        </Descriptions.Item>
                    </Descriptions>
                </Collapse.Panel>
                <Collapse.Panel key={2} header='Contract Info'>
                    <Descriptions size="small" bordered labelStyle={{width:200}}
                                  column={{xxl: 1, xl: 1, lg: 1, md: 1, sm: 1, xs: 1}}>
                        <Descriptions.Item label='PIID'>
                            {contract.piid || "N/A"}
                        </Descriptions.Item>
                    </Descriptions>
                    <Descriptions size="small" bordered style={{margin: '24px 0'}} labelStyle={{width:200}}
                                  column={{xxl: 1, xl: 1, lg: 1, md: 1, sm: 1, xs: 1}}>
                        <Descriptions.Item label='Title'>
                            {contract.title}
                        </Descriptions.Item>
                        <Descriptions.Item label='Solicitation ID'>
                            {contract.solicitationId}
                        </Descriptions.Item>
                        <Descriptions.Item label='Last Modified Date'>
                            {contract.lastModifiedDate ? moment(contract.lastModifiedDate).format('MMM DD, YYYY') : "N/A"}
                        </Descriptions.Item>
                    </Descriptions>
                    <Descriptions size="small" bordered style={{margin: '24px 0'}} labelStyle={{width:200}}
                                  column={{xxl: 1, xl: 1, lg: 1, md: 1, sm: 1, xs: 1}}>
                        <Descriptions.Item label='NAICS'>
                            {contract.naics}
                        </Descriptions.Item>
                        <Descriptions.Item label='PSC Associated'>
                            {contract.pscAssociated}
                        </Descriptions.Item>
                    </Descriptions>
                    <Descriptions size="small" bordered style={{margin: '24px 0'}} labelStyle={{width:200}}
                                  column={{xxl: 1, xl: 1, lg: 1, md: 1, sm: 1, xs: 1}}>
                        <Descriptions.Item label='PoP City/State'>
                            {contract.popCity} - {contract.popState}
                        </Descriptions.Item>
                        <Descriptions.Item label='National Interest Code'>
                            {contract.nationalInterestCode}
                        </Descriptions.Item>
                        <Descriptions.Item label='Prepared Date'>
                            {contract.preparedDate ? moment(contract.preparedDate).format('MMM DD, YYYY') : "N/A"}
                        </Descriptions.Item>
                        <Descriptions.Item label='Signed Date'>
                            {contract.signedDate ? moment(contract.signedDate).format('MMM DD, YYYY') : "N/A"}
                        </Descriptions.Item>
                        <Descriptions.Item label='Effective Date'>
                            {contract.effectiveDate ? moment(contract.effectiveDate).format('MMM DD, YYYY') : "N/A"}
                        </Descriptions.Item>
                        <Descriptions.Item label='Completion Date'>
                            {contract.completionDate ? moment(contract.completionDate).format('MMM DD, YYYY') : "N/A"}
                        </Descriptions.Item>
                        <Descriptions.Item label='Ultimate Completion Date'>
                            {contract.ultimateCompletionDate ? moment(contract.ultimateCompletionDate).format('MMM DD, YYYY') : "N/A"}
                        </Descriptions.Item>
                    </Descriptions>
                    <Descriptions size="small" bordered style={{margin: '24px 0'}} labelStyle={{width:200}}
                                  column={{xxl: 1, xl: 1, lg: 1, md: 1, sm: 1, xs: 1}}>
                        <Descriptions.Item label='Obligated Amount'>
                            ${contract.obligatedAmount ? NumbersUtil.toShortened(contract.obligatedAmount, 2) : 0}
                        </Descriptions.Item>
                        <Descriptions.Item label='Base and Obligated Totals'>
                            ${contract.baseAndObligatedTotals ? NumbersUtil.toShortened(contract.baseAndObligatedTotals, 2) : 0}
                        </Descriptions.Item>
                        <Descriptions.Item label='Total Value'>
                            ${contract.totalValue ? NumbersUtil.toShortened(contract.totalValue, 2) : 0}
                        </Descriptions.Item>
                        <Descriptions.Item label='Actions Taken'>
                            {contract.actionsTaken}
                        </Descriptions.Item>
                        <Descriptions.Item label='Modification Number'>
                            {contract.modificationNumber}
                        </Descriptions.Item>
                        <Descriptions.Item label='Modification Reason'>
                            {contract.modificationReason}
                        </Descriptions.Item>
                    </Descriptions>
                    <Descriptions size="small" bordered style={{marginTop: '24px'}} labelStyle={{width:200}}
                                  column={{xxl: 1, xl: 1, lg: 1, md: 1, sm: 1, xs: 1}}>
                        <Descriptions.Item label='Set Aside'>
                            {contract.setAside}
                        </Descriptions.Item>
                        <Descriptions.Item label='Offers Received'>
                            {contract.offersReceived}
                        </Descriptions.Item>
                        <Descriptions.Item label='Extent Completed'>
                            {contract.extentCompleted}
                        </Descriptions.Item>
                        <Descriptions.Item label='Multi-year Contract'>
                            {contract.multiYearContract}
                        </Descriptions.Item>
                        <Descriptions.Item label='Other than Full and Open Competition'>
                            {contract.otherThanFullAndOpenCompletion}
                        </Descriptions.Item>
                        <Descriptions.Item label='Selection Process'>
                            {contract.selectionProcess}
                        </Descriptions.Item>
                        <Descriptions.Item label='Ordering Procedure'>
                            {contract.orderingProcedure}
                        </Descriptions.Item>
                        <Descriptions.Item label='Subcontracting Information'>
                            {contract.subcontractingInformation}
                        </Descriptions.Item>
                        <Descriptions.Item label='Subcontracting Description'>
                            {contract.subcontractingDescription}
                        </Descriptions.Item>
                        <Descriptions.Item label='IDV or Award Type'>
                            {contract.idvOrAwardType}
                        </Descriptions.Item>
                        <Descriptions.Item label='Reason Not Award to Small Business'>
                            {contract.reasonNotAwardedToSmallBusinessDescription}
                        </Descriptions.Item>
                    </Descriptions>
                </Collapse.Panel>
                <Collapse.Panel key={3} header='Related IDV'>
                    <Descriptions size="small" bordered labelStyle={{width:200}}
                                  column={{xxl: 1, xl: 1, lg: 1, md: 1, sm: 1, xs: 1}}>
                        <Descriptions.Item label='Reference IDV'>
                            {contract.referenceIdv || "N/A"}
                        </Descriptions.Item>
                        <Descriptions.Item label='IDV NAICS'>
                            {contract.idvNaics}
                        </Descriptions.Item>
                        <Descriptions.Item label='IDV Mod Number'>
                            {contract.idvModNumber}
                        </Descriptions.Item>
                        <Descriptions.Item label='IDV Pricing'>
                            {contract.idvPricing}
                        </Descriptions.Item>
                        <Descriptions.Item label='IDV Pricing Description'>
                            {contract.idvPricingDescription}
                        </Descriptions.Item>
                        <Descriptions.Item label='IDV Signed Date'>
                            {contract.idvSignedDate ? moment(contract.idvSignedDate).format('MMM DD, YYYY') : "N/A"}
                        </Descriptions.Item>
                        <Descriptions.Item label='IDV Single or Multiple Awards'>
                            {contract.idvSingleOrMultipleAwards}
                        </Descriptions.Item>
                    </Descriptions>
                </Collapse.Panel>
                <Collapse.Panel key={4} header="Agency and Officer Information">
                    <Descriptions size="small" bordered labelStyle={{width:200}}
                                  column={{xxl: 1, xl: 1, lg: 1, md: 1, sm: 1, xs: 1}}>
                        <Descriptions.Item label='Department Name'>
                            {contract.departmentName || "N/A"}
                        </Descriptions.Item>
                        <Descriptions.Item label='Department ID'>
                            {contract.departmentId}
                        </Descriptions.Item>
                        <Descriptions.Item label='Funding Agency'>
                            {contract.fundingAgency}
                        </Descriptions.Item>
                    </Descriptions>
                    <Descriptions size="small" bordered style={{margin: '24px 0'}} labelStyle={{width:200}}
                                  column={{xxl: 1, xl: 1, lg: 1, md: 1, sm: 1, xs: 1}}>
                        <Descriptions.Item label='Agency Name'>
                            {contract.agencyName}
                        </Descriptions.Item>
                        <Descriptions.Item label='Agency ID'>
                            {contract.agencyId}
                        </Descriptions.Item>
                    </Descriptions>
                    <Descriptions size="small" bordered style={{margin: '24px 0'}} labelStyle={{width:200}}
                                  column={{xxl: 1, xl: 1, lg: 1, md: 1, sm: 1, xs: 1}}>
                        <Descriptions.Item label='Office Name'>
                            {contract.officeName}
                        </Descriptions.Item>
                        <Descriptions.Item label='Office ID'>
                            {contract.officeId}
                        </Descriptions.Item>
                    </Descriptions>
                    <Descriptions size="small" bordered style={{marginTop: '24px'}} labelStyle={{width:200}}
                                  column={{xxl: 1, xl: 1, lg: 1, md: 1, sm: 1, xs: 1}}>
                        <Descriptions.Item label='Prepared By'>
                            {contract.preparedBy}
                        </Descriptions.Item>
                        <Descriptions.Item label='Last Modified By'>
                            {contract.lastModifiedBy}
                        </Descriptions.Item>
                        <Descriptions.Item label='Last Modified By Email'>
                            {contract.lastModifiedByEmail}
                        </Descriptions.Item>
                    </Descriptions>
                </Collapse.Panel>
            </Collapse>


        </div>
    )
}

export default ContractDetails;